export enum BadgeColor {
  GREEN = "GREEN",
  RED = "RED",
  ORANGE = "ORANGE",
  YELLOW = "YELLOW",
  BLUE = "BLUE",
  INDIGO = "INDIGO",
  PURPLE = "PURPLE",
  PINK = "PINK",
  GRAY = "GRAY",
}

const colors: { [key in BadgeColor]: { text: string; icon: string; bg: string } } = {
  GREEN: { text: "text-green-800", icon: "bg-green-500", bg: "bg-green-100" },
  RED: { text: "text-red-800", icon: "bg-red-500", bg: "bg-red-100" },
  ORANGE: { text: "text-amber-800", icon: "bg-amber-500", bg: "bg-amber-100" },
  YELLOW: { text: "text-yellow-800", icon: "bg-yellow-500", bg: "bg-yellow-100" },
  BLUE: { text: "text-blue-800", icon: "bg-blue-500", bg: "bg-blue-100" },
  INDIGO: { text: "text-indigo-800", icon: "bg-indigo-500", bg: "bg-indigo-100" },
  PURPLE: { text: "text-purple-800", icon: "bg-purple-500", bg: "bg-purple-100" },
  PINK: { text: "text-pink-800", icon: "bg-pink-500", bg: "bg-pink-100" },
  GRAY: { text: "text-gray-600", icon: "bg-gray-500", bg: "bg-gray-100" },
};

const hoverColors: { [key in BadgeColor]: { text: string; bg: string } } = {
  GREEN: { text: "hover:text-green-900", bg: "hover:bg-green-300" },
  RED: { text: "hover:text-red-900", bg: "hover:bg-red-300" },
  ORANGE: { text: "hover:text-amber-900", bg: "hover:bg-amber-300" },
  YELLOW: { text: "hover:text-yellow-900", bg: "hover:bg-yellow-300" },
  BLUE: { text: "hover:text-blue-900", bg: "hover:bg-blue-300" },
  INDIGO: { text: "hover:text-indigo-900", bg: "hover:bg-indigo-300" },
  PURPLE: { text: "hover:text-purple-900", bg: "hover:bg-purple-300" },
  PINK: { text: "hover:text-pink-900", bg: "hover:bg-pink-300" },
  GRAY: { text: "hover:text-gray-700", bg: "hover:bg-gray-300" },
};

type BadgeProps = {
  text: string;
  color: BadgeColor;
  className?: string;
  onClick?: () => void;
  active?: boolean;
};
const Badge = ({ text, color, className = "", onClick, active = false }: BadgeProps) => {
  return (
    <span
      className={`inline-flex items-center rounded-full ${
        colors[color].bg
      } px-2.5 py-0.5 text-xs font-medium ${colors[color].text} ${
        onClick ? `${hoverColors[color].text} ${hoverColors[color].bg} hover:cursor-pointer` : ""
      } ${className}`}
      onClick={(event) => {
        if (onClick) {
          onClick();
          event.stopPropagation();
        }
      }}
    >
      {active && <span className={`rounded-full ${colors[color].icon} w-2 h-2 mr-1`}></span>}
      {text}
    </span>
  );
};

export default Badge;
